import { render, staticRenderFns } from "./orderDetail.vue?vue&type=template&id=ffd5e5ca&scoped=true"
import script from "./orderDetail.vue?vue&type=script&lang=js"
export * from "./orderDetail.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/order/orderDetail.css?vue&type=style&index=0&id=ffd5e5ca&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd5e5ca",
  null
  
)

export default component.exports